export default __webpack_public_path__ + "static/media/swap-player.a2eacb29.svg";